import axios from 'axios'

// 创建实例
const instance = axios.create({
  baseURL: process.env.NODE_ENV === 'production' ? process.env.BASE_API : '/',
  // baseURL: process.env.BASE_API,
  timeout: 60000
  // headers: {'X-Custom-Header': 'foobar'}
})

// request拦截器
instance.interceptors.request.use(
  config => {
    config.headers['Content-Type'] = 'application/json'
    return config
  },
  error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
instance.interceptors.response.use(
  response => {
    const code = response.status
    if (code < 200 || code > 300) {
      Notification.error({
        title: response.message
      })
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject('error')
    } else {
      return response.data
    }
  },
  error => {
    // let code = 0
    try {
      // code = error.response.data.status
    } catch (e) {
      if (error.toString().indexOf('Error: timeout') !== -1) {
        Notification.error({
          title: '网络请求超时',
          duration: 5000
        })
        return Promise.reject(error)
      }
    }
    return Promise.reject(error)
  }
)
export default instance


// WEBPACK FOOTER //
// ./src/api/request.js